import React, { useState, useEffect, useRef } from 'react'
import { Card, Modal, Collapse } from 'antd'
import { CaretRightOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import {
  paginationInit,
  formatMessageNew,
  downLoadFileBlob,
  formatStartTime,
  formatEndTime,
  initDateFormat,
  dateFormatYearMonthDay,
  isChineseFun,
  initValueAndLabel,
  uniqueFun
} from '@/utils/common'
import { RETAG_LIST } from '@/utils/types'
import { getReportPageRfid, exportSkuRfid, getDropDownList } from '@/services/rfid/rfidSku/rfidSkuReport'
import AntdTable from '@/components/table/AntdTable'
import SearchBar from '@/components/searchbar/SearchBar'
import RFIDSkuReportModalTable from '@/pages/rfid/rfidSku/components/RFIDSkuReportModalTable'
const startMonth = dayjs().subtract(1, 'day')
const endMonth = dayjs().subtract(1, 'day')
const RFIDSkuReport = () => {
  const [selectItem, setSelectItem] = useState({})
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const mounting = useRef(false)
  const [iBValuesChangeFlag, setIBValuesChangeFlag] = useState(false)
  const [oBValuesChangeFlag, setOBValuesChangeFlag] = useState(false)
  let formRef = useRef(null)
  let formRefIB = useRef(null)
  let formRefOB = useRef(null)
  const tableColumns = [
    {
      title: formatMessageNew('languageObj.rfidSkuReport.rfid'),
      dataIndex: 'epc',
      fixed: 'left',
      width: 240,
      render: (text, record) => {
        return (
          <div
            className="link_name word_break_all"
            onClick={() => {
              tableItemClick(record)
            }}
          >
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.productCode'),
      dataIndex: 'productCode',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.size'),
      dataIndex: 'size',
      width: 80,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.upc'),
      dataIndex: 'upc',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.productName'),
      dataIndex: 'productName',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.purchaseOrder'),
      dataIndex: 'purchaseOrder',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },

    {
      title: formatMessageNew('languageObj.rfidSkuReport.IB'),
      dataIndex: 'IB',
      children: [
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.IBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.IBCartonNumber'),
          dataIndex: 'ibCartonNumber',
          width: 150,
          render: (text, record) => {
            if (record.ibObsoleted === 1) {
              return <div className="word_break_all textLineThrough">{text}</div>
            } else {
              return <div className="word_break_all">{text}</div>
            }
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.IBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.IBOriginalCartonNumber'),
          dataIndex: 'ibOriginalCartonNumber',
          width: 180,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.rfidSkuReport.IBASN'),
          dataIndex: 'ibAsnNumber',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.IBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.IBTunnelID'),
          dataIndex: 'ibTunnelId',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.IBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.IBLPNSizeType'),
          dataIndex: 'ibLpnSizeType',
          width: 180,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.IBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.IBFactoryCode'),
          dataIndex: 'ibFactoryCode',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.IBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.IBCarrier'),
          dataIndex: 'ibCarrier',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.IBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.IBItemAttribute'),
          dataIndex: 'ibItemAttribute',
          width: 150,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.rfidSkuReport.IBGRDate'),
          dataIndex: 'ibGrDate',
          width: 120,
          render: text => {
            return <div className="word_break_all">{initDateFormat(text)}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.IBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.IBScanDate'),
          dataIndex: 'ibScanDate',
          width: 120,
          render: text => {
            return <div className="word_break_all">{initDateFormat(text)}</div>
          }
        }
      ]
    },
    {
      title: formatMessageNew('languageObj.rfidSkuReport.OB'),
      dataIndex: 'OB',
      children: [
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.OBCartonNumber'),
          dataIndex: 'obCartonNumber',
          width: 150,
          render: (text, record) => {
            if (record.obObsoleted === 1) {
              return <div className="word_break_all textLineThrough">{text}</div>
            } else {
              return <div className="word_break_all">{text}</div>
            }
          }
        },
        {
          title: formatMessageNew('languageObj.rfidSkuReport.OBDeliveryNoteNo'),
          dataIndex: 'obDeliveryNo',
          width: 150,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.rfidSkuReport.salesOrder'),
          dataIndex: 'obSalesOrder',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.OBMajor'),
          dataIndex: 'obMajor',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.OBTunnelID'),
          dataIndex: 'obTunnelId',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.OBTaskType'),
          dataIndex: 'obTaskType',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.OBSOType'),
          dataIndex: 'obSoType',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.OBCarrier'),
          dataIndex: 'obCarrier',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.OBRetag'),
          dataIndex: 'obRetag',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.OBShipFrom'),
          dataIndex: 'obShipFrom',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.OBShipTo'),
          dataIndex: 'obShipTo',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.OBStore'),
          dataIndex: 'obStore',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.OBItemAttribute'),
          dataIndex: 'obItemAttribute',
          width: 150,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.OBTrailerNumber'),
          dataIndex: 'obTrailerNumber',
          width: 150,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.OBCartonNetWeight'),
          dataIndex: 'obNetWeight',
          width: 150,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.OBCartonGrossWeight'),
          dataIndex: 'obGrossWeight',
          width: 180,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.rfidSkuReport.OBGIDate'),
          dataIndex: 'obGiDate',
          width: 120,
          render: text => {
            return <div className="word_break_all">{initDateFormat(text)}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
            formatMessageNew('languageObj.rfidSkuReport.OBScanDate'),
          dataIndex: 'obScanDate',
          width: 120,
          render: text => {
            return <div className="word_break_all">{initDateFormat(text)}</div>
          }
        }
      ]
    }
  ]

  let searchListInit = [
    {
      type: 'input',
      label: 'languageObj.rfidSkuReport.cartonNumber',
      key: 'cartonNumber',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.rfidSkuReport.productCode',
      key: 'productCode',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'timeRange',
      label: 'languageObj.rfidSkuReport.scanDate',
      key: 'scanDate',
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > dayjs().endOf('day')
        return falg
      },
      initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true',
      allowClear: false
    },
    {
      type: 'input',
      label: 'languageObj.rfidSkuReport.upc',
      key: 'upc',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.rfidSkuReport.tunnelID',
      key: 'tunnelId',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'input',
      label: 'languageObj.rfidSkuReport.rfid',
      key: 'epc',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)
  let ibSearchListInit = [
    {
      type: 'input',
      label: 'languageObj.rfidSkuReport.purchaseOrder',
      key: 'purchaseOrder',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.rfidSkuReport.IBASN',
      key: 'ibAsnNumber',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'timeRange',
      label: 'languageObj.rfidSkuReport.IBGRDate',
      key: 'ibGrDate',
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > dayjs().endOf('day')
        return falg
      },
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.rfidSkuReport.IBLPNSizeType',
      key: 'ibLpnSizeType',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.rfidSkuReport.IBFactoryCode',
      key: 'ibFactoryCode',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.rfidSkuReport.IBCarrier',
      key: 'ibCarrier',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },

    {
      type: 'input',
      label: 'languageObj.rfidSkuReport.IBItemAttribute',
      key: 'ibItemAttribute',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.rfidSkuReport.IBOriginalCartonNumber',
      key: 'ibOriginalCartonNumber',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]
  const [ibSearchList, setIbSearchList] = useState(ibSearchListInit)
  const getInitialValues = (ls = []) => {
    let obj = {}
    ls.forEach(item => {
      obj[item.key] = item.initialValues
    })
    return obj
  }
  let obSearchListInit = [
    {
      type: 'input',
      label: 'languageObj.rfidSkuReport.salesOrder',
      key: 'obSalesOrder',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.rfidSkuReport.OBDeliveryNoteNo',
      key: 'obDeliveryNo',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'timeRange',
      label: 'languageObj.rfidSkuReport.OBGIDate',
      key: 'obGiDate',
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg =
          // (current &&
          //   current <
          //     dayjs()
          //       .subtract(1, 'year')
          //       .subtract(1, 'day')) ||
          current && current > dayjs().endOf('day')
        return falg
      },
      initialValues: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.rfidSkuReport.OBTaskType',
      key: 'obTaskType',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.rfidSkuReport.OBMajor',
      key: 'obMajor',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.rfidSkuReport.OBSOType',
      key: 'obSoType',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },

    {
      type: 'input',
      label: 'languageObj.rfidSkuReport.OBShipFrom',
      key: 'obShipFrom',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.rfidSkuReport.OBShipTo',
      key: 'obShipTo',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.rfidSkuReport.OBRetag',
      allowClear: true,
      key: 'obRetag',
      initialValues: null,
      // mode: 'multiple',
      // maxTagCount: 1,
      selectList: RETAG_LIST,
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.rfidSkuReport.OBStore',
      key: 'obStore',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.rfidSkuReport.OBItemAttribute',
      key: 'obItemAttribute',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.rfidSkuReport.OBCarrier',
      key: 'obCarrier',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.rfidSkuReport.OBTrailerNumber',
      key: 'obTrailerNumber',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]
  const [obSearchList, setObSearchList] = useState(obSearchListInit)
  useEffect(() => {
    searchSelectDropFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const searchSelectDropFun = () => {
    getDropDownList().then(res => {
      searchListInit.forEach(itemFirst => {
        if (itemFirst.key === 'productCode' || itemFirst.key === 'tunnelId') {
          let arr = []
          if (itemFirst.key === 'productCode') {
            arr = res.resultData.productCodeList || []
          }
          if (itemFirst.key === 'tunnelId') {
            arr = res.resultData.tunnelIdList || []
          }
          itemFirst.selectList = initValueAndLabel(uniqueFun(arr, 2))
        }
      })
      setSearchList([...searchListInit])
      ibSearchList.forEach(itemFirst => {
        if (itemFirst.key === 'ibCarrier' || itemFirst.key === 'ibFactoryCode' || itemFirst.key === 'ibLpnSizeType') {
          let arr = []
          if (itemFirst.key === 'ibCarrier') {
            arr = res.resultData.ibCarrierList || []
          }
          if (itemFirst.key === 'ibFactoryCode') {
            arr = res.resultData.ibFactoryCodeList || []
          }
          if (itemFirst.key === 'ibLpnSizeType') {
            arr = res.resultData.ibLpnSizeTypeList || []
          }
          itemFirst.selectList = initValueAndLabel(uniqueFun(arr, 2))
        }
      })
      setIbSearchList([...ibSearchList])
      obSearchList.forEach(itemFirst => {
        if (itemFirst.key === 'obCarrier' || itemFirst.key === 'obSoType' || itemFirst.key === 'obTaskType') {
          let arr = []
          if (itemFirst.key === 'obCarrier') {
            arr = res.resultData.obCarrierList || []
          }
          if (itemFirst.key === 'obSoType') {
            arr = res.resultData.obSoTypeList || []
          }
          if (itemFirst.key === 'obTaskType') {
            arr = res.resultData.obTaskTypeList || []
          }
          itemFirst.selectList = initValueAndLabel(uniqueFun(arr, 2))
        }
      })
      setObSearchList([...obSearchList])
    })
  }

  useEffect(() => {
    if (mounting.current) searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  const searchDataBtn = () => {
    mounting.current = true
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    formRef && formRef.current && formRef.current.clearForm()
    formRefIB && formRefIB.current && formRefIB.current.clearForm()
    formRefOB && formRefOB.current && formRefOB.current.clearForm()
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
    setIBValuesChangeFlag(false)
    setOBValuesChangeFlag(false)
    setSelectedRowKeys([])
  }
  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const infoIb = (formRefIB.current && formRefIB.current.getSearchValue()) || {}
    const infoOb = (formRefOB.current && formRefOB.current.getSearchValue()) || {}
    const { scanDate } = info
    const { ibGrDate } = infoIb
    const { obGiDate } = infoOb
    const params = {
      ...info,
      ...infoIb,
      ...infoOb,
      epc: info.epc ? [info.epc] : [],
      scanStartTime: formatStartTime(scanDate),
      scanEndTime: formatEndTime(scanDate),
      giStartDate: formatStartTime(obGiDate),
      giEndDate: formatEndTime(obGiDate),
      grStartDate: formatStartTime(ibGrDate),
      grEndDate: formatEndTime(ibGrDate)
    }
    delete params.scanDate
    delete params.ibGrDate
    delete params.obGiDate
    return params
  }
  const searchDataFun = () => {
    setSelectedRowKeys([])
    const params = {
      ...getParams(),
      idList: [],
      size: pagination.pageSize,
      pageNo: pagination.currentPage
    }
    getReportPageRfid(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }

  const downLoadFun = () => {
    let idList = []
    if (selectedRowKeys && selectedRowKeys.length > 0) {
      idList = selectedRowKeys
    } else {
      idList = []
    }
    const params = {
      ...getParams(),
      idList: idList,
      ...isChineseFun()
    }
    exportSkuRfid(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  const tableItemClick = record => {
    setSelectItem(record)
    setModalVisible(true)
  }

  const handleModalCancel = () => {
    setModalVisible(false)
  }

  const handleModalOk = () => {
    setModalVisible(false)
  }

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  }
  const onChangeCollapse = (e, type) => {
    if (type === 'IB') {
      let isCollapse = false
      if (e.length > 0) {
        isCollapse = false
        // formRefIB.current && formRefIB.current.setValue(formRefIBValues.current || {})
      } else {
        isCollapse = true
        // let info = (formRefIB.current && formRefIB.current.getSearchValue()) || {}
        // formRefIBValues.current = info
      }
      setIBValuesChangeFlag(isCollapse && hasValuesChange(type))
    } else {
      let isCollapse = false
      if (e.length > 0) {
        isCollapse = false
      } else {
        isCollapse = true
      }
      setOBValuesChangeFlag(isCollapse && hasValuesChange(type))
    }
  }
  const hasValuesChange = type => {
    let defaultValues = {}
    let info = {}
    if (type === 'IB') {
      defaultValues = getInitialValues(ibSearchList)
      info = (formRefIB.current && formRefIB.current.getSearchValue()) || {}
    } else {
      defaultValues = getInitialValues(obSearchList)
      info = (formRefOB.current && formRefOB.current.getSearchValue()) || {}
    }
    let defalutStringify = JSON.stringify(defaultValues)
    let infoStringify = JSON.stringify(info)
    if (infoStringify === '{}' || defalutStringify === infoStringify) {
      return false
    } else {
      return true
    }
  }
  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={[...searchList]}
            // showSearchBtn={true}
            // showClearBtn={true}
            // onSearch={searchDataBtn}
            // onClear={searchClearDataBtn}
          />
          <Collapse
            className="mt8"
            size="small"
            onChange={e => {
              onChangeCollapse(e, 'IB')
            }}
            expandIcon={({ isActive }) => (
              <div className={iBValuesChangeFlag ? 'activeChange' : 'defaultChange'}>
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              </div>
            )}
            items={[
              {
                key: 'IB',
                label: (
                  <div className={iBValuesChangeFlag ? 'activeChange' : 'defaultChange'}>
                    {formatMessageNew('languageObj.rfidSkuReport.IBTitle') +
                      formatMessageNew('languageObj.rfidSkuReport.filter')}
                  </div>
                ),
                children: (
                  <>
                    <SearchBar ref={formRefIB} searchList={[...ibSearchList]} />
                  </>
                )
              }
            ]}
          />
          <Collapse
            className="mt8"
            size="small"
            onChange={e => {
              onChangeCollapse(e, 'OB')
            }}
            expandIcon={({ isActive }) => (
              <div className={oBValuesChangeFlag ? 'activeChange' : 'defaultChange'}>
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              </div>
            )}
            items={[
              {
                key: 'OB',
                label: (
                  <div className={oBValuesChangeFlag ? 'activeChange' : 'defaultChange'}>
                    {formatMessageNew('languageObj.rfidSkuReport.OBTitle') +
                      formatMessageNew('languageObj.rfidSkuReport.filter')}
                  </div>
                ),
                children: (
                  <>
                    <SearchBar ref={formRefOB} searchList={[...obSearchList]} />
                  </>
                )
              }
            ]}
          />
          <div className="mt8">
            <SearchBar
              searchList={[]}
              showSearchBtn={true}
              showClearBtn={true}
              onSearch={searchDataBtn}
              onClear={searchClearDataBtn}
            />
          </div>
        </div>
        <div className="content-container overflow_visible mt20">
          <AntdTable
            rowKey={(record, index) => record.id || index}
            rowSelection={rowSelection}
            dataSource={tableList}
            columns={tableColumns}
            // 独一无二的标识，不能重复
            columnsKey="rfidSkuReportColumns"
            onDownload={downLoadFun}
            pagination={pagination}
            onChange={handleTableChange}
          />
        </div>
      </Card>
      <Modal
        open={modalVisible}
        maskClosable={false}
        destroyOnClose={true}
        className="nike_modal"
        width="85%"
        title={formatMessageNew('languageObj.rfidSkuReport.rfidHistory')}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        footer={null}
      >
        <RFIDSkuReportModalTable selectItem={selectItem} />
      </Modal>
    </div>
  )
}
export default RFIDSkuReport
